import dynamic from 'next/dynamic';
import type { NeedHelpSectionCheckoutProps } from './cart/needHelp';
import type { FooterProps } from './footer/Footer';
import type { FooterKeyLinksProps } from './footer/footerKeyLinks/FooterKeyLinks';
import type { NotificationBarProps } from './header/notificationBar/NotificationBar';
import type { MegaMenuProps } from './navigation/megaMenu/MegaMenu';

/* eslint-disable promise/prefer-await-to-then */
export const HeaderComponent = dynamic(() => import('./header/Header').then((mod) => mod.HeaderComponent));

export const MarketingMessage = dynamic(() => import('./header/MarketingMessage').then((mod) => mod.MarketingMessage));

export const NavigationBar = dynamic(() =>
  import('./header/navigationBar/NavigationBar').then((mod) => mod.NavigationBar),
);

export const NotificationBar = dynamic<NotificationBarProps>(() =>
  import('./header/notificationBar/NotificationBar').then((mod) => mod.NotificationBar),
);

export const PromotionalLinksNav = dynamic(() =>
  import('./header/PromotionalLinksNav').then((mod) => mod.PromotionalLinksNav),
);

export const SubNav = dynamic(() => import('./header/subNav/SubNav').then((mod) => mod.SubNav));

export const ScrollToTop = dynamic(() => import('./footer/scrollToTop/ScrollToTop').then((mod) => mod.ScrollToTop));

export const SmallFooterLinks = dynamic(() => import('./footer/SmallFooterLinks').then((mod) => mod.SmallFooterLinks));

export const FooterIconsBlock = dynamic(() =>
  import('./footer/footerIconsBlock/FooterIconsBlock').then((mod) => mod.FooterIconsBlock),
);

export const NewsletterSignUp = dynamic(() =>
  import('./footer/newsletterSignUp/NewsletterSignUp').then((mod) => mod.NewsletterSignUp),
);

export const FooterAccordion = dynamic(() =>
  import('./footer/footerAccordion/FooterAccordion').then((mod) => mod.FooterAccordion),
);

export const CategoryFeaturedCard = dynamic(() =>
  import('./navigation/CategoryFeaturedCard').then((mod) => mod.CategoryFeaturedCard),
);
export const MainLinksColumn = dynamic(() => import('./footer/MainLinksColumn').then((mod) => mod.MainLinksColumn));
export const SiteSwitcher = dynamic(() => import('./footer/SiteSwitcher').then((mod) => mod.SiteSwitcher));
export const FooterComponent = dynamic<FooterProps>(() => import('./footer/Footer').then((mod) => mod.Footer));

export const MegaMenu = dynamic<MegaMenuProps>(() =>
  import('./navigation/megaMenu/MegaMenu').then((mod) => mod.MegaMenu),
);

export const HeaderNavigation = dynamic(() =>
  import('./navigation/headerNavigation/HeaderNavigation').then((mod) => mod.HeaderNavigation),
);

export const AmpliencePaymentMethods = dynamic(() =>
  import('./paymentMethods/AmpliencePaymentMethods').then((mod) => mod.AmpliencePaymentMethods),
);

export const MediaCarousel = dynamic(() => import('./carousel/MediaCarousel').then((mod) => mod.MediaCarousel));

export const EmptyBasket = dynamic(() => import('./cart/emptyBasket/EmptyBasket').then((mod) => mod.EmptyBasket));

export const PriceTooltip = dynamic(() => import('./tooltip/PriceTooltip').then((mod) => mod.PriceTooltip));

export const ProductCarousel = dynamic(() =>
  import('./carousel/productCarousel/ProductCarousel').then((mod) => mod.ProductCarousel),
);

export const FooterKeyLinks = dynamic<FooterKeyLinksProps>(() =>
  import('./footer/footerKeyLinks/FooterKeyLinks').then((mod) => mod.FooterKeyLinks),
);

export const TrendingCarousel = dynamic(() =>
  import('./carousel/TrendingCarousel').then((mod) => mod.TrendingCarousel),
);

export const SizeCalculator = dynamic(() =>
  import('./sizeCalculator/SizeCalculator').then((mod) => mod.SizeCalculator),
);

export const ShippingSection = dynamic(() =>
  import('./shippingSection/ShippingSection').then((mod) => mod.ShippingSection),
);

export const RelatedProductsCarousel = dynamic(() =>
  import('./carousel/relatedProductsCarousel/RelatedProductsCarousel').then((mod) => mod.RelatedProductsCarousel),
);

export const SimpleAccordions = dynamic(() =>
  import('./simpleAccordions/SimpleAccordions').then((mod) => mod.SimpleAccordions),
);

export const Spacer = dynamic(() => import('./spacer/Spacer').then((mod) => mod.Spacer));

export const NeedHelpSectionCheckout = dynamic<NeedHelpSectionCheckoutProps>(() =>
  import('./cart/needHelp').then((mod) => mod.NeedHelpSectionCheckout),
);
/* eslint-enable promise/prefer-await-to-then */
